import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css, ThemeContext, createGlobalStyle, ThemeProvider } from 'styled-components';
import iconAlertInformational from './assets/alert-informational~noWiHihm.svg';
import iconAlertAttention from './assets/alert-attention~HVOZtPpc.svg';
import iconAlertError from './assets/alert-error~zqIwhnlk.svg';
import iconCloseDefault from './assets/close-default~vxwkjAox.svg';
import iconCloseSuccess from './assets/close-success~fWagLNnq.svg';
import iconCloseInformational from './assets/close-informational~bdnXMfqs.svg';
import iconCloseAttention from './assets/close-attention~XecrsNRs.svg';
import iconCloseFeatured from './assets/close-featured~ocAvrDmV.svg';
import iconCloseError from './assets/close-error~TdogtIzp.svg';
import _extends from '@babel/runtime/helpers/extends';
import checkedIcon from './assets/checked~Lnohpwym.svg';
import checkedAndDisabledIcon from './assets/checkedAndDisabled~bfcNnocc.svg';
import disabledIcon from './assets/disabled~zNgugndW.svg';
import uncheckedIcon from './assets/unchecked~xrZuNQoI.svg';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import Select, { components } from 'react-select';
import { Controller, useWatch } from 'react-hook-form';
import Creatable from 'react-select/creatable';
import disabledIcon$1 from './assets/disabled~iKoZevNN.svg';
import disabledAndSelectedIcon from './assets/disabledAndSelected~sWukjYLi.svg';
import selectedIcon from './assets/selected~qYqwSmwA.svg';
import unselectedIcon from './assets/unselected~LKvgczrq.svg';
import { normalize } from 'styled-normalize';
export { normalize } from 'styled-normalize';

var _templateObject$d, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var types = ['default', 'success', 'informational', 'attention', 'featured', 'error']; // TODO add alert icons for all types

var typeIconAlertMap = {
  informational: iconAlertInformational,
  attention: iconAlertAttention,
  error: iconAlertError
};
var typeIconCloseMap = {
  default: iconCloseDefault,
  success: iconCloseSuccess,
  informational: iconCloseInformational,
  attention: iconCloseAttention,
  featured: iconCloseFeatured,
  error: iconCloseError
};
var StyledAlertMessage = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose([""])));
var StyledAlertIcon = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose([""])));
var StyledAlertContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose([""])));
var StyledCloseButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose([""])));

var Alert = function Alert(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$hideAlertIcon = _ref.hideAlertIcon,
      hideAlertIcon = _ref$hideAlertIcon === void 0 ? false : _ref$hideAlertIcon,
      onDismiss = _ref.onDismiss,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  type = types.indexOf(type) >= 0 ? type : 'default';

  var _useState = useState(false),
      isDismiss = _useState[0],
      setIsDismiss = _useState[1];

  var isShowAlert = !isDismiss;

  var dismissAlert = function dismissAlert() {
    setIsDismiss(true);
    if (onDismiss) onDismiss();
  };

  return isShowAlert ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(StyledAlertMessage, null, !hideAlertIcon && typeIconAlertMap[type] && /*#__PURE__*/React.createElement(StyledAlertIcon, null, /*#__PURE__*/React.createElement("img", {
    src: typeIconAlertMap[type],
    alt: "Error"
  })), /*#__PURE__*/React.createElement(StyledAlertContent, null, children), /*#__PURE__*/React.createElement(StyledCloseButton, {
    type: "button",
    className: "alert-btn-close",
    onClick: dismissAlert
  }, /*#__PURE__*/React.createElement("img", {
    src: typeIconCloseMap[type],
    alt: "Close"
  })))) : null;
};

var StyledAlert = styled(Alert)(function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    --alert-color: ", ";\n    --alert-bg-color: ", "19;\n\n    ", " {\n      font-size: 14px;\n      line-height: 1.25;\n      border-radius: 8px;\n      padding: 11px 15px;\n      border: 2px solid;\n      margin-bottom: 20px;\n      display: flex;\n      flex: 1;\n      justify-content: space-between;\n      align-items: flex-start;\n      background-color: var(--alert-bg-color);\n      color: ", "C0;\n      border-color: var(--alert-color);\n      ", " {\n        margin-right: 15px;\n        margin-top: 5px;\n        width: 25px;\n        img {\n          width: 100%;\n        }\n      }\n      ", " {\n        width: 100%;\n      }\n      ", " {\n        padding: 0;\n        border: 0;\n        background: none;\n        height: 15px;\n        margin-left: 15px;\n        margin-top: 5px;\n        cursor: pointer;\n      }\n    }\n  "])), type && type in theme.colors.semantic ? theme.colors.semantic[type] : theme.colors.coolGray.cool800, type && type in theme.colors.semantic ? theme.colors.semantic[type] : theme.colors.coolGray.cool600, StyledAlertMessage, theme.colors.neutralGray.neutral900, StyledAlertIcon, StyledAlertContent, StyledCloseButton);
});

var BaseButton = function BaseButton(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      onClick = _ref.onClick,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", {
      className: className,
      disabled: disabled,
      id: id,
      onClick: onClick,
      // A bug in this rule doesn't properly recognize default props so it
      // needs to be disabled for now
      // eslint-disable-next-line react/button-has-type
      type: type,
      value: text
    }, children || text)
  );
};

var _templateObject$c;

var buttonStyles = function buttonStyles(_ref) {
  var height = _ref.height;
  return css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  // define variables used to center text vertically in elements other than \"button\"\n  --btn-height: ", "px;\n  --btn-line-height: 16px;\n  --btn-padding-y: calc((var(--btn-height) - var(--btn-line-height)) / 2);\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  // use min-height to avoid clipped or off-centered text\n  min-height: var(--btn-height);\n  letter-spacing: 0.06em;\n  line-height: var(--btn-line-height);\n  // center text vertically\n  padding-top: var(--btn-padding-y);\n  padding-bottom: var(--btn-padding-y);\n  // include default button styles for use with other element types (e.g. a)\n  display: inline-block;\n  text-align: center;\n  text-decoration: none;\n  &:disabled {\n    cursor: not-allowed;\n  }\n  // Prevent square box around the button when it is clicked:\n  &:focus {\n    outline: unset;\n  }\n"])), height, function (props) {
    return props.theme.fonts.component.button;
  });
};

var _templateObject$b;

var Button = styled(BaseButton)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  ", "\n"])), buttonStyles({
  height: 20
}));

var ButtonLink = function ButtonLink(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      onClick = _ref.onClick,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type;
  return /*#__PURE__*/React.createElement("button", {
    className: className,
    disabled: disabled,
    id: id,
    onClick: onClick,
    // A bug in this rule doesn't properly recognize default props so it
    // needs to be disabled for now
    // eslint-disable-next-line react/button-has-type
    type: type,
    value: text
  }, children || text);
};

var StyledButtonLink = styled(ButtonLink)(function (_ref2) {
  var theme = _ref2.theme,
      underline = _ref2.underline;
  return {
    backgroundColor: 'inherit',
    color: 'inherit',
    fontSize: 'inherit',
    fontFamily: theme.fonts.component.buttonLink,
    // override default margin in Safari
    margin: '0',
    padding: '0',
    lineHeight: '16px',
    border: 'none',
    cursor: 'pointer',
    textDecoration: underline ? 'underline' : 'none',
    '&:disabled': {
      color: theme.colors.coolGray.cool500,
      cursor: 'not-allowed'
    },
    // Prevent square box around the button when it is clicked:
    '&:focus': {
      outline: 'unset'
    }
  };
});

var _templateObject$a;

var PrimaryButton = styled(BaseButton)(function (_ref) {
  var theme = _ref.theme;
  var component = theme.colors.component.PrimaryButton;
  return css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n    ", ";\n    border-radius: 8px;\n    padding-left: 16px;\n    padding-right: 16px;\n    max-height: 50px;\n    font-size: 16px;\n    font-weight: 700;\n    text-transform: none;\n    font-family: ", ";\n    color: ", ";\n    background-color: ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:hover {\n      background-color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n      pointer-events: none;\n    }\n  "])), buttonStyles({
    height: 50
  }), theme.fontFamilies.robotoCondensed, component.default.text, component.default.background, component.hover.background, component.disabled.background);
});

var _templateObject$9;

var SecondaryButton = styled(BaseButton)(function (_ref) {
  var theme = _ref.theme;
  var component = theme.colors.component.SecondaryButton;
  return css(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n    ", ";\n    border-radius: 8px;\n    padding-left: 16px;\n    padding-right: 16px;\n    max-height: 50px;\n    font-size: 16px;\n    font-weight: 700;\n    text-transform: none;\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n      pointer-events: none;\n    }\n  "])), buttonStyles({
    height: 50
  }), theme.fontFamilies.robotoCondensed, component.default.background, component.default.text, component.default.border, component.hover.background, component.hover.text, component.disabled.background);
});

var replaceWhitespace = function replaceWhitespace(_ref) {
  var string = _ref.string;
  return string.replace(/\s/g, '-');
};

var constructId = function constructId(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      value = _ref2.value;

  if (id) {
    return id;
  }

  return name + "-" + replaceWhitespace({
    string: typeof value === 'string' ? value : String(value)
  });
};

var labelColor = function labelColor(_ref3) {
  var disabled = _ref3.disabled,
      enabled = _ref3.enabled,
      error = _ref3.error,
      theme = _ref3.theme;

  if (disabled) {
    return theme.colors.coolGray.cool500;
  }

  if (error) {
    return theme.colors.semantic.error;
  }

  return enabled || theme.colors.coolGray.cool600;
};

var Checkbox = function Checkbox(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      value = _ref.value;
  var finalId = constructId({
    id: id,
    name: name,
    value: value
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: finalId,
    name: name,
    ref: register ? register(_extends({
      required: required
    }, validations)) : undefined,
    type: "checkbox",
    value: value
  }), /*#__PURE__*/React.createElement("label", {
    className: "small-paragraph-text" + (disabled ? ' disabled' : ''),
    htmlFor: finalId
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }), label));
};

var StyledCheckbox = styled(Checkbox)(function (_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      errors = _ref2.errors,
      name = _ref2.name,
      theme = _ref2.theme;
  var hasError = errors && !!errors[name];
  return {
    '&:not(:last-child)': {
      marginBottom: '10px'
    },
    input: {
      display: 'none'
    },
    label: {
      alignItems: 'flex-start',
      color: labelColor({
        disabled: disabled,
        enabled: theme.colors.coolGray.cool900,
        error: hasError,
        theme: theme
      }),
      cursor: 'pointer',
      display: 'flex',
      // Increased lineHeight from 14px to match checkbox height so the vertical centering of the
      // text and the checkbox matches:
      lineHeight: '16px',
      marginBottom: '0',
      '&:before': {
        content: "url(" + uncheckedIcon + ")",
        height: '16px',
        marginRight: '6px',
        width: '16px'
      },
      '&.disabled': {
        color: theme.colors.coolGray.cool500,
        cursor: 'not-allowed',
        '&:before': {
          content: "url(" + disabledIcon + ")"
        }
      }
    },
    'input:checked + label': {
      '&:before': {
        content: "url(" + checkedIcon + ")"
      },
      '&.disabled:before': {
        content: "url(" + checkedAndDisabledIcon + ")"
      }
    }
  };
});

var _templateObject$8;

var CheckboxGroup = function CheckboxGroup(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      name = _ref.name,
      checkboxOptions = _ref.checkboxOptions,
      register = _ref.register;
  return /*#__PURE__*/React.createElement("fieldset", {
    className: className
  }, checkboxOptions.map(function (checkboxOption, index) {
    return /*#__PURE__*/React.createElement(StyledCheckbox, {
      defaultChecked: defaultValue === checkboxOption.value,
      disabled: disabled || checkboxOption.disabled || undefined,
      id: checkboxOption.id || undefined,
      key: typeof checkboxOption.value === 'string' || typeof checkboxOption.value === 'number' ? checkboxOption.value : index,
      label: checkboxOption.label,
      name: name,
      register: register,
      value: checkboxOption.value
    });
  }));
};

var StyledCheckboxGroup = styled(CheckboxGroup)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  border: 0;\n  margin: 0 0 20px;\n"]))); // ReactSelect has a rather opinionated theme that needs to be adapted
// to match the DFH design system colors, which is done by passing a
// theme prop that is a function to override the defaults.

var overrideTheme = function overrideTheme(themeContext) {
  return function (reactSelectTheme) {
    return _extends({}, reactSelectTheme, {
      colors: {
        primary: themeContext.colors.grayscale.gray5,
        primary75: themeContext.colors.grayscale.gray5,
        primary50: themeContext.colors.grayscale.gray5,
        primary25: themeContext.colors.grayscale.gray5,
        danger: themeContext.colors.semantic.error,
        dangerLight: themeContext.colors.semantic.error,
        neutral0: themeContext.colors.grayscale.white,
        neutral5: themeContext.colors.grayscale.gray5,
        neutral10: themeContext.colors.grayscale.gray10,
        neutral20: themeContext.colors.grayscale.gray20,
        neutral30: themeContext.colors.grayscale.gray20,
        neutral40: themeContext.colors.grayscale.gray40,
        neutral50: themeContext.colors.grayscale.gray40,
        neutral60: themeContext.colors.grayscale.gray60,
        neutral70: themeContext.colors.grayscale.gray60,
        neutral80: themeContext.colors.grayscale.black,
        neutral90: themeContext.colors.grayscale.black
      },
      spacing: _extends({}, reactSelectTheme.spacing, {
        controlHeight: 32
      })
    });
  };
}; // Break this out because otherwise it became very difficult to read the styling
// of the disabled code in Dropdown and DropdownBasic.


var disabledClassNames = ['.react-select__control--is-disabled', '.react-select__input--is-disabled', '.react-select__placeholder', '.react-select__placeholder--is-disabled', '.react-select__single-value--is-disabled', '.react-select__dropdown-indicator'].join(', '); // DropdownBasic relies on the weird result of overrideTheme, which is just a
// clone of the React Select theme with at least color values replaced with
// DFH colors for consistency with other form fields, which means the standard
// labelColor helper is of no use--the color structure is completely different.

var dropdownBasicLabelColor = function dropdownBasicLabelColor(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      theme = _ref.theme;

  if (disabled) {
    return theme.colors.neutral20;
  }

  if (error) {
    return theme.colors.danger;
  }

  return theme.colors.neutral60;
};

var _templateObject$7;

var dropdownStyles = function dropdownStyles(_ref) {
  var prompt = _ref.prompt;
  return css(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 14px;\n  margin-bottom: 20px;\n  &.react-select--is-disabled {\n    ", " {\n      &,\n      &:before {\n        color: ", ";\n      }\n    }\n  }\n  .react-select__control {\n    cursor: pointer;\n    transition: border 0.15s;\n    &,\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      box-shadow: none;\n    }\n    &.react-select__control--is-focused {\n      border-color: ", ";\n    }\n    // insert prompt at beginning of control\n    &:before {\n      color: ", ";\n      content: '", "';\n      display: block;\n      // pad right of prompt, and pad vertically in case control wraps\n      padding: 8px 0 8px 12px;\n    }\n  }\n  .react-select__container {\n    display: inline-block;\n  }\n  .react-select__indicator {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n    // shrink indicators from 20px\n    svg: {\n      height: 15px;\n      width: 15px;\n    }\n  }\n  .react-select__indicator-separator {\n    display: none;\n  }\n  .react-select__indicator ~ .react-select__indicator-separator {\n    // display separator when preceded by indicator\n    display: block;\n  }\n  .react-select__dropdown-indicator {\n    // emphasize dropdown indicator regardless of hover\n    color: ", ";\n  }\n  .react-select__option {\n    cursor: pointer;\n    &.react-select__option--is-selected {\n      color: ", ";\n    }\n  }\n"])), disabledClassNames, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.coolGray.cool500;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.grayscale.white;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.coolGray.cool200;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.coolGray.cool500;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.coolGray.cool900;
  }, prompt, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.coolGray.cool500;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.coolGray.cool900;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.coolGray.cool900;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.coolGray.cool900;
  });
};

var _templateObject$6;

var _excluded$7 = ["className", "control", "defaultValue", "disabled", "isClearable", "isSearchable", "name", "placeholder", "required"];

var Dropdown = function Dropdown(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      control = _ref.control,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable,
      name = _ref.name,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Controller, {
    as: /*#__PURE__*/React.createElement(Select, Object.assign({
      className: className,
      classNamePrefix: "react-select",
      isClearable: isClearable,
      isDisabled: disabled,
      isSearchable: isSearchable,
      placeholder: placeholder,
      theme: overrideTheme(themeContext)
    }, otherProps)),
    control: control,
    defaultValue: defaultValue,
    name: name,
    rules: {
      required: required
    }
  });
};

var StyledDropdown = styled(Dropdown)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var _ref2$prompt = _ref2.prompt,
      prompt = _ref2$prompt === void 0 ? '' : _ref2$prompt;
  return dropdownStyles({
    prompt: prompt
  });
});
/* eslint-disable react/destructuring-assignment */

var DropdownBasicControlComponent = function DropdownBasicControlComponent(props) {
  var children = props.children,
      isFocused = props.isFocused,
      selectProps = props.selectProps,
      theme = props.theme;
  var hasError = selectProps.name && !!selectProps.errors[selectProps.name];
  var floatLabelToTop = selectProps.label && (selectProps.placeholder || !!selectProps.value || isFocused);
  return /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(components.Control, Object.assign({}, props), /*#__PURE__*/React.createElement("div", {
    style: {
      bottom: '0',
      color: dropdownBasicLabelColor({
        disabled: selectProps.isDisabled,
        error: hasError,
        theme: theme // Note: this is the React Select theme from overrideTheme, not the usual theme.

      }),
      cursor: selectProps.disabled ? 'not-allowed' : 'text',
      fontSize: floatLabelToTop ? '10px' : '14px',
      left: '15px',
      position: 'absolute',
      top: floatLabelToTop ? '9px' : '23px',
      transition: '0.2s'
    }
  }, selectProps.label, hasError && selectProps.required ? ' Required' : '', selectProps.required ? "\xA0*" : ''), children));
};
/* eslint-enable react/destructuring-assignment */


var DropdownBasic = function DropdownBasic(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      control = _ref.control,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? {} : _ref$errors,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      name = _ref.name,
      options = _ref.options,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Controller, {
    as: /*#__PURE__*/React.createElement(Select, {
      className: className,
      classNamePrefix: "react-select",
      components: {
        Control: DropdownBasicControlComponent
      },
      errors: errors,
      isClearable: isClearable,
      isDisabled: disabled,
      isSearchable: isSearchable,
      label: label,
      options: options,
      placeholder: placeholder,
      // The DropdownBasicControlComponent can't access the rules object so
      // required also needs to be passed directly so it's accessible there:
      required: required,
      theme: overrideTheme(themeContext)
    }),
    control: control,
    defaultValue: defaultValue,
    name: name,
    rules: {
      required: required
    }
  });
};

var StyledDropdownBasic = styled(DropdownBasic)(function (_ref2) {
  var _reactSelectIsD;

  var errors = _ref2.errors,
      name = _ref2.name,
      theme = _ref2.theme;
  var hasError = errors && !!errors[name];
  return {
    boxSizing: 'border-box',
    flex: 1,
    marginBottom: '20px',
    position: 'relative',
    '&.react-select--is-disabled': (_reactSelectIsD = {}, _reactSelectIsD[disabledClassNames] = {
      color: theme.colors.coolGray.cool500
    }, _reactSelectIsD),
    '.react-select__value-container': {
      alignItems: 'center',
      display: 'flex',
      flex: '1',
      padding: '2px 8px 2px 13px'
    },
    '.react-select__control': {
      backgroundColor: theme.colors.coolGray.cool150,
      borderRadius: '8px',
      boxSizing: 'border-box',
      cursor: 'pointer',
      fontSize: '14px',
      height: '60px',
      lineHeight: 1,
      position: 'relative',
      transition: 'border 0.15s',
      width: '100%',
      '&, &:hover': {
        border: "1px solid " + (hasError ? theme.colors.semantic.error : 'transparent'),
        boxShadow: 'none'
      },
      '&.react-select__control--is-focused': {
        border: "1px solid " + (hasError ? theme.colors.semantic.error : theme.colors.brand.blue),
        outline: 'none'
      }
    },
    '.react-select__container': {
      display: 'inline-block'
    },
    '.react-select__indicator': {
      color: theme.colors.coolGray.cool500,
      '&:hover': {
        color: theme.colors.coolGray.cool900
      },
      // shrink indicators from 20px
      svg: {
        height: '15px',
        width: '15px'
      }
    },
    '.react-select__dropdown-indicator': {
      // emphasize dropdown indicator regardless of hover
      color: theme.colors.coolGray.cool900
    },
    '.react-select__indicator-separator': {
      display: 'none'
    },
    '.react-select__indicator ~ .react-select__indicator-separator': {
      // display separator when preceded by indicator
      display: 'block'
    },
    '.react-select__placeholder': {
      color: theme.colors.coolGray.cool600
    },
    '.react-select__input, .react-select__placeholder, .react-select__single-value': {
      fontSize: 'calc(13px + (1px / 3))',
      lineHeight: 'normal',
      paddingTop: '8px'
    },
    '.react-select__input, .react-select__single-value': {
      color: theme.colors.coolGray.cool900
    },
    '.react-select__option': {
      cursor: 'pointer',
      fontSize: '12px',
      lineHeight: '14px',
      '&.react-select__option--is-selected': {
        color: theme.colors.coolGray.cool900
      }
    }
  };
});

var _templateObject$5;

var _excluded$6 = ["className", "control", "defaultValue", "disabled", "isClearable", "isSearchable", "name", "placeholder", "required", "validations"];

var DropdownCreatable = function DropdownCreatable(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      control = _ref.control,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable,
      name = _ref.name,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Controller, {
    as: /*#__PURE__*/React.createElement(Creatable, Object.assign({
      className: className,
      classNamePrefix: "react-select",
      isClearable: isClearable,
      isDisabled: disabled,
      isSearchable: isSearchable,
      placeholder: placeholder,
      theme: overrideTheme(themeContext)
    }, otherProps)),
    control: control,
    defaultValue: defaultValue,
    name: name,
    rules: _extends({
      required: required
    }, validations)
  });
};

var StyledDropdownCreatable = styled(DropdownCreatable)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var _ref2$prompt = _ref2.prompt,
      prompt = _ref2$prompt === void 0 ? '' : _ref2$prompt;
  return dropdownStyles({
    prompt: prompt
  });
});
var DropdownInternal = styled(StyledDropdown)({
  '.react-select__control': {
    boxSizing: 'border-box',
    fontSize: '14px',
    lineHeight: '16px',
    minHeight: '50px'
  }
});

var DropdownSubtle = function DropdownSubtle(props) {
  return /*#__PURE__*/React.createElement(StyledDropdown, Object.assign({
    isClearable: false,
    isSearchable: false
  }, props));
};

var StyledDropdownSubtle = styled(DropdownSubtle)(function (_ref) {
  var theme = _ref.theme;
  return {
    fontFamily: theme.fonts.component.dropDownSubtle,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '16px',
    textTransform: 'uppercase',
    '.react-select__control': {
      cursor: 'pointer',
      '&, &:hover, &.react-select__control--is-focused': {
        backgroundColor: 'inherit',
        border: 'none',
        borderRadius: '0'
      },
      '&:before': {
        // remove padding around prompt
        padding: 0
      }
    },
    '.react-select__value-container': {
      paddingRight: '0'
    }
  };
});
var _excluded$5 = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "type", "validations"];

var Input = function Input(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var hasError = errors && !!errors[name];

  var _useState = useState(!!defaultValue),
      isFilled = _useState[0],
      setIsFilled = _useState[1];

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    className: isFilled ? 'filled' : '',
    defaultValue: defaultValue,
    disabled: disabled,
    id: id || name,
    name: name,
    onChange: function onChange(event) {
      return setIsFilled(!!event.target.value);
    },
    placeholder: placeholder,
    ref: register ? register(_extends({
      required: required
    }, validations)) : undefined,
    required: required,
    type: type
  }, other)), /*#__PURE__*/React.createElement("label", {
    className: disabled ? 'disabled' : '',
    htmlFor: id || name
  }, label, hasError && required ? ' Required' : '', required ? "\xA0*" : ''));
};

var StyledInput = styled(Input)(function (_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      errors = _ref2.errors,
      name = _ref2.name,
      theme = _ref2.theme;
  var hasError = errors && !!errors[name];
  return {
    fontSize: '14px',
    marginBottom: '20px',
    position: 'relative',
    input: {
      // prescribe box-sizing for consistent layout
      boxSizing: 'border-box',
      backgroundColor: theme.colors.coolGray.cool150,
      border: "1px solid " + (hasError ? theme.colors.semantic.error : 'transparent'),
      borderRadius: '8px',
      color: disabled ? theme.colors.coolGray.cool500 : theme.colors.coolGray.cool900,
      cursor: disabled ? 'not-allowed' : 'text',
      height: '60px',
      lineHeight: '16px',
      padding: '8px 15px 0',
      transition: 'border 0.15s',
      '&:focus': {
        border: "1px solid " + (hasError ? theme.colors.semantic.error : theme.colors.brand.blue),
        outline: 'none'
      },
      '&::placeholder': {
        color: disabled ? theme.colors.coolGray.cool500 : theme.colors.coolGray.cool600
      }
    },
    label: {
      bottom: '0',
      color: labelColor({
        disabled: disabled,
        error: hasError,
        theme: theme
      }),
      cursor: disabled ? 'not-allowed' : 'text',
      left: '15px',
      lineHeight: '1',
      pointerEvents: 'none',
      position: 'absolute',
      top: '24px',
      transition: '0.2s',
      // Workaround for legacy Edge so the label doesn't overlap the text entered by the user
      // but instead is always in the upper left as if the input already has text in it:
      '@supports (-ms-ime-align: auto)': {
        fontSize: '10px',
        top: '10px'
      }
    },
    'input:focus + label, input:placeholder-shown + label, input.filled + label': {
      fontSize: '10px',
      top: '10px'
    },
    '&, input': {
      width: '100%'
    }
  };
});
var _excluded$4 = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "validations"];

var EmailInput = function EmailInput(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(StyledInput, Object.assign({
    className: className,
    defaultValue: defaultValue,
    disabled: disabled,
    errors: errors,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    register: register,
    required: required,
    type: "email",
    validations: validations
  }, other));
};

var _excluded$3 = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "validations"];

var NumberInput = function NumberInput(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(StyledInput, Object.assign({
    className: className,
    defaultValue: defaultValue,
    disabled: disabled,
    errors: errors,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    register: register,
    required: required,
    type: "number",
    validations: validations
  }, other));
};

var StyledNumber = styled(NumberInput)(function (_ref2) {
  var hideArrows = _ref2.hideArrows;

  if (hideArrows) {
    // Note that for some reason these particular pseudo-selectors cannot be separated from the
    // input[type=number] without breaking the final CSS:
    return {
      // Hide arrows in Chrome:
      'input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
        margin: '0',
        '-webkit-appearance': 'none'
      },
      // Hide arrows in Firefox:
      'input[type=number]': {
        '-moz-appearance': 'textfield'
      }
    };
  }

  return {};
});
var _excluded$2 = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "validations"];

var PasswordInput = function PasswordInput(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(StyledInput, Object.assign({
    className: className,
    defaultValue: defaultValue,
    disabled: disabled,
    errors: errors,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    register: register,
    required: required,
    type: "password",
    validations: validations
  }, other));
};

var _templateObject$4;

var RadioButton = function RadioButton(_ref) {
  var className = _ref.className,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      value = _ref.value;
  var finalId = constructId({
    id: id,
    name: name,
    value: value
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: finalId,
    name: name,
    ref: register,
    type: "radio",
    value: value
  }), /*#__PURE__*/React.createElement("label", {
    className: disabled ? 'disabled' : '',
    htmlFor: finalId
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }), label));
};

var StyledRadioButton = styled(RadioButton)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  label {\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 14px;\n    min-height: 35px;\n    min-width: 119px;\n    padding-left: 9px;\n    padding-right: 9px;\n    &.disabled {\n      color: ", ";\n      cursor: not-allowed;\n      .icon {\n        background-image: url(", ");\n      }\n    }\n  }\n  input {\n    display: none;\n  }\n  .icon {\n    background-image: url(", ");\n    height: 17px;\n    margin-right: 6px;\n    width: 17px;\n  }\n  input:checked + label {\n    font-weight: 500;\n    .icon {\n      background-image: url(", ");\n    }\n    &.disabled .icon {\n      background-image: url(", ");\n    }\n  }\n"])), function (props) {
  return props.theme.colors.coolGray.cool500;
}, disabledIcon$1, unselectedIcon, selectedIcon, disabledAndSelectedIcon);

var _templateObject$3;

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var className = _ref.className,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue,
      disabled = _ref.disabled,
      name = _ref.name,
      radioButtonOptions = _ref.radioButtonOptions,
      register = _ref.register;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, radioButtonOptions.map(function (radioButtonOption, index) {
    return /*#__PURE__*/React.createElement(StyledRadioButton, {
      defaultChecked: defaultValue === radioButtonOption.value,
      disabled: disabled || radioButtonOption.disabled || undefined,
      id: radioButtonOption.id || undefined,
      key: typeof radioButtonOption.value === 'string' || typeof radioButtonOption.value === 'number' ? radioButtonOption.value : index,
      label: radioButtonOption.label,
      name: name,
      register: register,
      value: radioButtonOption.value
    });
  }));
};

var StyledRadioButtonGroup = styled(RadioButtonGroup)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: nowrap;\n  margin-bottom: 20px;\n  ", " {\n    label {\n      border: 2px solid ", ";\n      border-left: none;\n    }\n    &:first-of-type label {\n      border-left: 2px solid ", ";\n      border-radius: 4px 0 0 4px;\n    }\n    &:last-of-type label {\n      border-radius: 0 4px 4px 0;\n    }\n  }\n"])), StyledRadioButton, function (props) {
  return props.theme.colors.coolGray.cool200;
}, function (props) {
  return props.theme.colors.coolGray.cool200;
});

var _templateObject$2;

var Selector = function Selector(_ref) {
  var className = _ref.className,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      _ref$showAsDisabled = _ref.showAsDisabled,
      showAsDisabled = _ref$showAsDisabled === void 0 ? false : _ref$showAsDisabled,
      value = _ref.value;
  var finalId = constructId({
    id: id,
    name: name,
    value: value
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: finalId,
    name: name,
    ref: register,
    type: "radio",
    value: value
  }), /*#__PURE__*/React.createElement("label", {
    className: (disabled ? 'disabled' : '') + " " + (showAsDisabled ? 'show-as-disabled' : ''),
    htmlFor: finalId
  }, label));
};

var StyledSelector = styled(Selector)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  // Configuring height and left/right padding via a variable to allow for adjusting it based on\n  // the border width (and potentially based on contents later on if needed):\n  --base-height: 64px;\n  --base-padding-horizontal: 16px;\n\n  label {\n    align-items: center;\n    background-color: ", ";\n    border: 2px solid transparent;\n    border-radius: 8px;\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%;\n    min-height: var(--base-height);\n    padding-left: var(--base-padding-horizontal);\n    padding-right: var(--base-padding-horizontal);\n    &.disabled,\n    &.show-as-disabled {\n      color: ", ";\n    }\n    &.disabled {\n      cursor: not-allowed;\n    }\n  }\n  input {\n    display: none;\n  }\n  input:checked + label {\n    border-color: ", ";\n    // Remove pixels from the height and the left/right to account for the impact of the border\n    // on the computed height and width so changing the checked Selector doesn't cause it to\n    // grow or shrink:\n    min-height: var(--base-height - 4px);\n    padding-left: var(--base-padding-horizontal - 2px);\n    padding-right: var(--base-padding-horizontal - 2px);\n  }\n"])), function (props) {
  return props.theme.colors.coolGray.cool150;
}, function (props) {
  return props.theme.colors.coolGray.cool900;
}, function (props) {
  return props.theme.colors.coolGray.cool500;
}, function (props) {
  return props.theme.colors.brand.blue;
});

var _templateObject$1;

var SelectorGroup = function SelectorGroup(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      name = _ref.name,
      register = _ref.register,
      selectorOptions = _ref.selectorOptions;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, selectorOptions.map(function (selectorOption, index) {
    return /*#__PURE__*/React.createElement(StyledSelector, {
      defaultChecked: defaultValue === selectorOption.value,
      disabled: disabled || selectorOption.disabled || undefined,
      id: selectorOption.id || undefined,
      key: typeof selectorOption.value === 'string' || typeof selectorOption.value === 'number' ? selectorOption.value : index,
      label: selectorOption.label,
      name: name,
      register: register,
      showAsDisabled: selectorOption.showAsDisabled || undefined,
      value: selectorOption.value
    });
  }));
};

var StyledSelectorGroup = styled(SelectorGroup)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: nowrap;\n  margin-bottom: 20px;\n  ", " {\n    margin-right: 8px;\n    &:last-of-type {\n      margin-right: 0;\n    }\n  }\n"])), StyledSelector);
var _excluded$1 = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "validations"];

var TelInput = function TelInput(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(StyledInput, Object.assign({
    className: className,
    defaultValue: defaultValue,
    disabled: disabled,
    errors: errors,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    register: register,
    required: required,
    type: "tel",
    validations: validations
  }, other));
};

var _excluded = ["className", "defaultValue", "disabled", "errors", "id", "label", "name", "placeholder", "register", "required", "validations"];

var TextInput = function TextInput(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? {} : _ref$validations,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledInput, Object.assign({
    className: className,
    defaultValue: defaultValue,
    disabled: disabled,
    errors: errors,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    register: register,
    required: required,
    type: "text",
    validations: validations
  }, other));
};

var animationTimeout = 400;
var animationTimeoutCss = animationTimeout / 1000 + "s";

var Toggle = function Toggle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      control = _ref.control,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$preventChange = _ref.preventChange,
      preventChange = _ref$preventChange === void 0 ? false : _ref$preventChange,
      id = _ref.id,
      name = _ref.name,
      register = _ref.register;
  var isChecked = useWatch({
    control: control,
    name: name,
    defaultValue: defaultChecked
  });

  var _useState = useState(isChecked),
      isShowChecked = _useState[0],
      setIsShowChecked = _useState[1];

  var onLabelClick = function onLabelClick() {
    if (!disabled && preventChange) {
      setIsShowChecked(!isChecked);
      setTimeout(function () {
        setIsShowChecked(isChecked);
      }, animationTimeout);
    }
  }; // Slider styles are dictated by input state unless `preventChange` is `true`. In
  // that case, the label is disconnected from the input, and visual state must be
  // derived from the checkbox value (set programmatically).


  useEffect(function () {
    if (preventChange) {
      setIsShowChecked(isChecked);
    }
  }, [isChecked, preventChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: id,
    name: name,
    ref: register,
    type: "checkbox"
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: preventChange ? '' : id,
    onClick: onLabelClick,
    className: preventChange && isShowChecked ? 'show-checked' : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "sliderContainer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "slider"
  })), /*#__PURE__*/React.createElement("span", null, children)));
};

var StyledToggle = styled(Toggle)(function (_ref2) {
  var _ref3;

  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$checkedMeansPen = _ref2.checkedMeansPending,
      checkedMeansPending = _ref2$checkedMeansPen === void 0 ? false : _ref2$checkedMeansPen,
      _ref2$preventChange = _ref2.preventChange,
      preventChange = _ref2$preventChange === void 0 ? false : _ref2$preventChange,
      theme = _ref2.theme;
  var colors = {
    checked: {
      default: checkedMeansPending ? theme.colors.brand.categoryOrange : theme.colors.component.link,
      disabled: checkedMeansPending ? theme.colors.brand.categoryOrange + "96" : theme.colors.component.link + "96"
    },
    unchecked: {
      default: theme.colors.coolGray.cool500,
      disabled: theme.colors.coolGray.cool400
    }
  };
  return _ref3 = {
    input: {
      display: 'none'
    },
    label: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      flexWrap: 'nowrap',
      position: 'relative'
    },
    '.sliderContainer': {
      display: 'inline-block',
      flex: '0 0 52px',
      height: '32px',
      marginRight: '12px',
      position: 'relative'
    },
    '.slider': {
      backgroundColor: disabled ? colors.unchecked.disabled : colors.unchecked.default,
      borderRadius: '19px',
      bottom: '0',
      left: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      transition: animationTimeoutCss,
      '&:before': {
        backgroundColor: theme.colors.grayscale.white,
        borderRadius: '50%',
        content: '""',
        height: '26px',
        left: '3px',
        position: 'absolute',
        top: '3px',
        transition: animationTimeoutCss,
        width: '26px'
      }
    }
  }, _ref3[(preventChange ? '' : 'input:checked + label .slider, ') + ".show-checked .slider"] = {
    backgroundColor: disabled ? colors.checked.disabled : colors.checked.default,
    // 'Move' the circle to the right of the containing pill:
    '&:before': {
      transform: 'translateX(21px)'
    }
  }, _ref3;
});
var sansSerifFamilies = "'Helvetica', 'Arial', 'sans-serif'";
var fontFamilies$1 = {
  gotham: "'Gotham', " + sansSerifFamilies,
  gothamCondensed: "'Gotham Condensed', " + sansSerifFamilies,
  gothamNarrow: "'Gotham Narrow', " + sansSerifFamilies,
  gothamXNarrow: "'Gotham XNarrow', " + sansSerifFamilies,
  roboto: "'Roboto', " + sansSerifFamilies,
  robotoCondensed: "'Roboto Condensed', " + sansSerifFamilies
};
/** @deprecated use theme.fontFamilies.roboto */

var fontFamilies = fontFamilies$1.roboto;
/** @deprecated use theme.fontFamilies.gotham */

var gothamFamilies = fontFamilies$1.gotham;
/** @deprecated use theme.fontFamilies.gotham */

var gothamBoldFamilies = fontFamilies$1.gotham;
/** @deprecated use theme.fontFamilies.robotoCondensed */

var robotoCondensedFamilies = fontFamilies$1.robotoCondensed;
var colors = {
  // https://www.tailwindshades.com/#color=357.06293706293707%2C68.42105263157895%2C59.01960784313726&step-up=8&step-down=11&hue-shift=0&name=mandy&base-stop=4&v=1&overrides=e30%3D
  mandyRed: {
    shade100: '#F1B6B9',
    shade200: '#EB9498',
    shade300: '#E47177',
    shade400: '#DE4F56',
    shade500: '#CE272F',
    shade600: '#9F1E24',
    shade700: '#701519',
    shade800: '#410C0F',
    shade900: '#110304'
  },
  // https://www.tailwindshades.com/#color=1.2500000000000013%2C62.06896551724137%2C45.490196078431374&step-up=8&step-down=11&hue-shift=0&name=tall-poppy&base-stop=5&v=1&overrides=e30%3D
  poppyRed: {
    shade100: '#E9A3A2',
    shade200: '#E18381',
    shade300: '#DA6260',
    shade400: '#D2423F',
    shade500: '#BC2F2C',
    shade600: '#8F2421',
    shade700: '#611817',
    shade800: '#340D0C',
    shade900: '#060201'
  },
  // https://www.tailwindshades.com/#color=6.499999999999999%2C53.09734513274334%2C55.68627450980392&step-up=8&step-down=11&hue-shift=0&name=chestnut-rose&base-stop=5&v=1&overrides=e30%3D
  chestnutRed: {
    shade100: '#F0D3CF',
    shade200: '#E7B6B0',
    shade300: '#DD9990',
    shade400: '#D47C71',
    shade500: '#CA5F52',
    shade600: '#AE4335',
    shade700: '#843228',
    shade800: '#59221B',
    shade900: '#2E110E'
  },
  // https://www.tailwindshades.com/#color=6.857142857142857%2C77.77777777777777%2C55.88235294117647&step-up=8&step-down=11&hue-shift=0&name=cinnabar&base-stop=5&v=1&overrides=e30%3D
  cinnabarOrange: {
    shade100: '#F8CEC8',
    shade200: '#F4ADA4',
    shade300: '#EF8C80',
    shade400: '#EB6C5B',
    shade500: '#E64B37',
    shade600: '#CB2E19',
    shade700: '#9A2313',
    shade800: '#68170D',
    shade900: '#360C07'
  },
  // https://www.tailwindshades.com/#color=28.275862068965523%2C73.72881355932203%2C53.72549019607843&step-up=8&step-down=11&hue-shift=0&name=zest&base-stop=5&v=1&overrides=e30%3D
  zestOrange: {
    shade100: '#F5D9C0',
    shade200: '#F0C49C',
    shade300: '#EBAF79',
    shade400: '#E59955',
    shade500: '#E08432',
    shade600: '#BD681D',
    shade700: '#8D4D15',
    shade800: '#5C330E',
    shade900: '#2B1807'
  },
  // https://www.tailwindshades.com/#color=54.8780487804878%2C82.82828282828282%2C61.1764705882353&step-up=8&step-down=11&hue-shift=0&name=starship&base-stop=5&v=1&overrides=e30%3D
  starYellow: {
    shade100: '#FCFADF',
    shade200: '#F9F3BA',
    shade300: '#F5ED95',
    shade400: '#F2E66F',
    shade500: '#EEE04A',
    shade600: '#E9D717',
    shade700: '#B7A911',
    shade800: '#83790C',
    shade900: '#504A08'
  },
  // https://www.tailwindshades.com/#color=139.45945945945945%2C33.333333333333336%2C43.529411764705884&step-up=8&step-down=11&hue-shift=0&name=fruit-salad&base-stop=6&v=1&overrides=e30%3D
  saladGreen: {
    shade100: '#C7E3D0',
    shade200: '#ACD5B9',
    shade300: '#91C8A3',
    shade400: '#75BA8C',
    shade500: '#5AAD75',
    shade600: '#4a9462',
    shade700: '#376F49',
    shade800: '#254930',
    shade900: '#122418'
  },
  // https://www.tailwindshades.com/#color=171.70731707317074%2C50.20408163265305%2C51.96078431372548&step-up=8&step-down=11&hue-shift=0&name=puerto-rico&base-stop=5&v=1&overrides=e30%3D
  seaGreen: {
    shade100: '#C2EBE5',
    shade200: '#A3E0D8',
    shade300: '#84D6CB',
    shade400: '#66CCBE',
    shade500: '#47C2B1',
    shade600: '#349D8E',
    shade700: '#267368',
    shade800: '#184942',
    shade900: '#0A1E1C'
  },
  // https://www.tailwindshades.com/#color=189.47368421052633%2C100%2C22.35294117647059&step-up=8&step-down=11&hue-shift=0&name=blue-stone&base-stop=8&v=1&overrides=e30%3D
  stoneBlue: {
    shade100: '#91EEFF',
    shade200: '#68E7FF',
    shade300: '#3FE1FF',
    shade400: '#16DAFF',
    shade500: '#00C7EC',
    shade600: '#00A5C4',
    shade700: '#00829B',
    shade800: '#006072',
    shade900: '#00313A'
  },
  // https://www.tailwindshades.com/#color=188.07692307692307%2C41.935483870967744%2C48.627450980392155&step-up=8&step-down=11&hue-shift=0&name=hippie-blue&base-stop=5&v=1&overrides=e30%3D
  hippieBlue: {
    shade100: '#B9DDE2',
    shade200: '#9CCFD6',
    shade300: '#7FC0CB',
    shade400: '#62B2BF',
    shade500: '#48A2B0',
    shade600: '#387D88',
    shade700: '#275960',
    shade800: '#173439',
    shade900: '#070F11'
  },
  // https://www.tailwindshades.com/#color=202.17391304347825%2C18.548387096774192%2C51.37254901960784&step-up=8&step-down=11&hue-shift=0&name=faded-blue&base-stop=5&v=1&overrides=e30%3D
  fadedBlue: {
    shade100: '#CDD7DC',
    shade200: '#B5C3CC',
    shade300: '#9CB0BB',
    shade400: '#849CAB',
    shade500: '#6C899A',
    shade600: '#546C7A',
    shade700: '#3D4F59',
    shade800: '#263138',
    shade900: '#0F1416'
  },
  // https://www.tailwindshades.com/#color=213.33333333333331%2C72.97297297297298%2C14.509803921568626&step-up=8&step-down=11&hue-shift=0&name=downriver&base-stop=8&v=1&overrides=e30%3D
  riverBlue: {
    shade100: '#7DAEEB',
    shade200: '#5A98E5',
    shade300: '#3682E0',
    shade400: '#206DCD',
    shade500: '#1B5AAA',
    shade600: '#154787',
    shade700: '#103563',
    shade800: '#0A2240',
    shade900: '#02080F'
  },
  // https://www.tailwindshades.com/#color=218.57142857142856%2C68.29268292682927%2C32.15686274509804&step-up=8&step-down=11&hue-shift=0&name=chathams-blue&base-stop=7&v=1&overrides=e30%3D
  chathamsBlue: {
    shade100: '#AAC3EF',
    shade200: '#88AAE8',
    shade300: '#6592E2',
    shade400: '#4379DC',
    shade500: '#2763CF',
    shade600: '#2052AC',
    shade700: '#1A428A',
    shade800: '#112B5B',
    shade900: '#08152C'
  },
  // https://www.tailwindshades.com/#color=226.70454545454544%2C75.2136752136752%2C54.11764705882353&step-up=8&step-down=11&hue-shift=0&name=royal-blue&base-stop=5&v=1&overrides=e30%3D
  royalBlue: {
    shade100: '#C1CDF6',
    shade200: '#9DB0F1',
    shade300: '#7993EC',
    shade400: '#5676E7',
    shade500: '#3259E2',
    shade600: '#1B40C1',
    shade700: '#143090',
    shade800: '#0D1F5E',
    shade900: '#060F2D'
  },
  // https://www.tailwindshades.com/#color=212.94117647058823%2C73.91304347826087%2C13.529411764705882&step-up=8&step-down=11&hue-shift=0&name=black-pearl&base-stop=8&v=1&overrides=e30%3D
  blackPearlBlue: {
    shade100: '#78ACEB',
    shade200: '#5496E5',
    shade300: '#3180E0',
    shade400: '#1E6CCA',
    shade500: '#1959A6',
    shade600: '#144683',
    shade700: '#0E335F',
    shade800: '#09203C',
    shade900: '#02060B'
  },
  // https://www.tailwindshades.com/#color=274.6875%2C41.55844155844156%2C30.19607843137255&step-up=8&step-down=11&hue-shift=0&name=jacarta&base-stop=7&v=1&overrides=e30%3D
  darkPurple: {
    shade100: '#CBB0DF',
    shade200: '#B893D3',
    shade300: '#A577C7',
    shade400: '#925ABB',
    shade500: '#7D45A7',
    shade600: '#68398A',
    shade700: '#522D6D',
    shade800: '#341D45',
    shade900: '#160C1E'
  },
  // https://www.tailwindshades.com/#color=291.7241379310345%2C77.67857142857142%2C56.07843137254902&step-up=8&step-down=11&hue-shift=0&name=medium-purple&base-stop=7&v=1&overrides=e30%3D
  mediumPurple: {
    shade100: '#F2C9F8',
    shade200: '#E9A5F4',
    shade300: '#E080EF',
    shade400: '#D75CEB',
    shade500: '#CE38E6',
    shade600: '#B41ACC',
    shade700: '#88139A',
    shade800: '#5C0D69',
    shade900: '#300737'
  },
  // Based on PMS Cool Gray 11 C
  coolGray: {
    cool100: '#f8f9fa',
    cool150: '#f2f3f5',
    cool200: '#eaebee',
    cool250: '#e3e5e9',
    cool300: '#dfe1e5',
    cool400: '#d0d3d8',
    cool500: '#b1b4b9',
    cool600: '#727477',
    cool700: '#4d4f53',
    cool800: '#37393d',
    cool900: '#232427'
  },
  neutralGray: {
    neutral100: '#f9f9f9',
    neutral200: '#ececec',
    neutral300: '#e2e2e2',
    neutral400: '#d4d4d4',
    neutral500: '#b5b5b5',
    neutral600: '#757575',
    neutral700: '#505050',
    neutral800: '#3a3a3a',
    neutral900: '#252525'
  },
  // Based on PMS Warm Gray 11 C
  warmGray: {
    warm100: '#faf9f8',
    warm200: '#f0ebe8',
    warm300: '#e7e1dd',
    warm400: '#dbd3cd',
    warm500: '#bfb3ab',
    warm600: '#807269',
    warm700: '#594e47',
    warm800: '#423932',
    warm900: '#2a2420'
  },
  grayscale: {
    white: '#FFFFFF',
    gray5: '#F2F2F2',
    gray10: '#E5E5E5',
    gray20: '#CCCCCC',
    gray40: '#999999',
    gray60: '#666666',
    black: '#000000'
  }
};

var colors$1 = _extends({}, colors, {
  text: {
    primary: colors.coolGray.cool900,
    secondary: colors.coolGray.cool600
  },
  brand: {
    white: '#FFFFFF',

    /** rgb(10, 34, 64), colors.riverBlue.shade800, PMS 289 C */
    blue: '#0A2240',

    /** primary logo color - rgb(230, 75, 55), colors.cinnabarOrange.shade500, PMS 7417 C */
    orange: '#E64B37',

    /** primary logo color - rgb(230, 75, 55), colors.cinnabarOrange.shade500, PMS 7417 C */
    red: '#E64B37',

    /** secondary logo color- rgb(84, 86, 90), PMS Cool Gray 11 C */
    gray: '#54565A',

    /** rgb(26, 66, 138), colors.chathamsBlue.shade700, PMS 7687 C */
    categoryBlue: '#1A428A',

    /** rgb(74, 148, 98), colors.saladGreen.shade600, PMS 7730 C */
    categoryGreen: '#4A9462',

    /** rgb(224, 132, 50), colors.zestOrange.shade500, PMS 7413 C */
    categoryOrange: '#E08432',

    /** rgb(82, 45, 109), colors.darkPurple.shade700, PMS 269 C */
    categoryPurple: '#522D6D',

    /** rgb(188, 47, 44), colors.poppyRed.shade500, PMS 7620 C */
    categoryRed: '#BC2F2C',

    /** rgb(0, 96, 114), colors.stoneBlue.shade800, PMS 3155 C */
    categoryTurquoise: '#006072',

    /** rgb(238, 224, 74), colors.starYellow.shade500, PMS 603 C */
    categoryYellow: '#EEE04A'
  },
  component: {
    surfaceBlue: '#F0F5F9',
    textDark: '#051120',
    buttonDisabled: '#C9D6DF',
    checkoutBorderLight: '#D6D6D6',
    backgroundDarkBlue: colors.blackPearlBlue.shade800,
    link: colors.cinnabarOrange.shade500,
    linkVisited: colors.mediumPurple.shade500,
    PrimaryButton: {
      default: {
        background: colors.riverBlue.shade800,
        text: colors.grayscale.white
      },
      hover: {
        // lighten(saturate(colors.riverBlue.shade800, 0.52), 1.76) + alpha(0.8)
        background: '#0B2648CC'
      },
      disabled: {
        background: colors.coolGray.cool400
      }
    },
    SecondaryButton: {
      default: {
        background: colors.grayscale.white,
        border: colors.riverBlue.shade800,
        text: colors.riverBlue.shade800
      },
      hover: {
        // lighten(saturate(colors.riverBlue.shade800, 0.52), 1.76) + alpha(0.8)
        background: '#0B2648CC',
        text: colors.grayscale.white
      },
      disabled: {
        background: colors.coolGray.cool400
      }
    }
  },
  semantic: {
    attention: colors.hippieBlue.shade500,
    error: colors.mandyRed.shade400,
    featured: colors.chestnutRed.shade500,
    informational: colors.fadedBlue.shade500,
    success: colors.seaGreen.shade500
  }
});

var fonts = {
  global: {
    body: fontFamilies$1.roboto,
    headers: fontFamilies$1.gotham,
    smallHeaders: fontFamilies$1.robotoCondensed
  },
  component: {
    button: fontFamilies$1.robotoCondensed,
    buttonLink: fontFamilies$1.roboto,
    dropDownSubtle: fontFamilies$1.robotoCondensed
  }
};
var typography = {
  h1: {
    fontFamily: fonts.global.headers,
    fontSize: '36px',
    fontWeight: 'bold',
    lineHeight: 1,
    marginTop: 0,
    marginBottom: '0.42em'
  },
  h2: {
    fontFamily: fonts.global.headers,
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: 1.2,
    marginTop: 0,
    marginBottom: '0.42em'
  },
  h3: {
    fontFamily: fonts.global.headers,
    fontSize: '22px',
    fontWeight: 'bold',
    letterSpacing: '-0.01em',
    lineHeight: 1.2,
    marginTop: 0,
    marginBottom: '0.42em'
  },
  h4: {
    fontFamily: fonts.global.headers,
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: 1,
    marginTop: 0,
    marginBottom: '0.5em'
  },
  h5: {
    fontFamily: fonts.global.smallHeaders,
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '0.06em',
    lineHeight: 1.14,
    marginTop: 0,
    marginBottom: '0.57em'
  },
  body1: {
    fontFamily: fonts.global.body,
    fontSize: '20px',
    lineHeight: 1.7023,
    marginTop: 0,
    marginBottom: '24pt'
  },
  body2: {
    fontFamily: fonts.global.body,
    fontSize: '16px',
    lineHeight: 1.43,
    marginTop: 0,
    marginBottom: '24pt'
  },
  body3: {
    color: colors$1.coolGray.cool600,
    fontFamily: fonts.global.body,
    fontSize: '12px',
    lineHeight: 1.17,
    marginTop: 0,
    marginBottom: '24pt'
  }
};
var theme = {
  colors: colors$1,
  fontFamilies: fontFamilies$1,
  fonts: fonts,
  typography: typography
};

var _templateObject;

var globalStyles = function globalStyles(theme) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  html {\n    -webkit-font-smoothing: antialiased; // antialiasing\n    -moz-osx-font-smoothing: grayscale; // antialiasing\n    // use border-box sizing by default\n    box-sizing: border-box;\n  }\n\n  *,\n  *::before,\n  *::after {\n    // best-practice to inherit box-sizing from parent\n    box-sizing: inherit;\n  }\n\n  body,\n  select,\n  option {\n    color: ", ";\n    ", ";\n  }\n\n  html,\n    body,\n    /* Need to force Gatsby's automatically-added divs to fill the whole parent container: */\n    #___gatsby,\n    #gatsby-focus-wrapper {\n    margin: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  .gotham {\n    font-family: ", ";\n  }\n\n  .roboto {\n    font-family: ", ";\n  }\n\n  .gothamBold {\n    font-family: ", ";\n    font-weight: bold;\n  }\n\n  .robotoCondensed {\n    font-family: ", ";\n  }\n\n  /* TODO: figure out if this should be an h4 once that is locked down in the design system. */\n  .small-h3 {\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n\n  .paragraph-text {\n    ", ";\n  }\n\n  .big-paragraph,\n  .big-paragraph-text {\n    ", ";\n  }\n\n  .small-paragraph,\n  .small-paragraph-text {\n    ", ";\n  }\n\n  .small-margin-bottom {\n    margin-bottom: 8px;\n  }\n\n  a {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n\n  hr {\n    color: ", ";\n    margin: 39px auto;\n    max-width: 450px;\n  }\n\n  strong {\n    font-weight: bold;\n  }\n\n  @media (min-width: 768px) {\n    hr {\n      max-width: 450px;\n    }\n  }\n"])), theme.colors.coolGray.cool900, theme.typography.body2, theme.fontFamilies.gotham, theme.fontFamilies.roboto, theme.fontFamilies.gotham, theme.fontFamilies.robotoCondensed, theme.typography.body2, theme.typography.body1, theme.typography.body3, theme.colors.coolGray.cool400);
};

var typographyStyles = function typographyStyles(theme) {
  return {
    h1: theme.typography.h1,
    h2: theme.typography.h2,
    h3: theme.typography.h3,
    h4: theme.typography.h4,
    h5: theme.typography.h5,
    p: theme.typography.body2
  };
};

var GlobalStyle = createGlobalStyle(function (_ref) {
  var _ref$excludeNormalize = _ref.excludeNormalize,
      excludeNormalize = _ref$excludeNormalize === void 0 ? false : _ref$excludeNormalize;
  return !excludeNormalize && normalize;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      theme$1 = _ref2$theme === void 0 ? theme : _ref2$theme;
  return globalStyles(theme$1);
}, function (_ref3) {
  var _ref3$includeTypograp = _ref3.includeTypography,
      includeTypography = _ref3$includeTypograp === void 0 ? false : _ref3$includeTypograp,
      _ref3$theme = _ref3.theme,
      theme$1 = _ref3$theme === void 0 ? theme : _ref3$theme;
  return includeTypography && typographyStyles(theme$1);
});
GlobalStyle.propTypes = {
  excludeNormalize: PropTypes.bool,
  includeTypography: PropTypes.bool
};

var Theme = function Theme(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, Object.assign({
    theme: theme
  }, props));
};

export { StyledAlert as Alert, Button, StyledButtonLink as ButtonLink, StyledCheckbox as Checkbox, StyledCheckboxGroup as CheckboxGroup, StyledDropdown as Dropdown, StyledDropdownBasic as DropdownBasic, StyledDropdownCreatable as DropdownCreatable, DropdownInternal, StyledDropdownSubtle as DropdownSubtle, EmailInput, GlobalStyle, StyledInput as Input, StyledNumber as NumberInput, PasswordInput, PrimaryButton, StyledRadioButton as RadioButton, StyledRadioButtonGroup as RadioButtonGroup, SecondaryButton, StyledSelector as Selector, StyledSelectorGroup as SelectorGroup, TelInput, TextInput, Theme, StyledToggle as Toggle, fontFamilies, globalStyles, gothamBoldFamilies, gothamFamilies, robotoCondensedFamilies, theme, typographyStyles };